module.exports = __webpack_public_path__ + "static/media/Dysmate-C_compressed.fff4bd28.pdf";